
	import {
		Request
	} from '@/api/request';
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch,
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
    import {
        getCouponList, permissionList
    } from "@/api/http";

	const columnList: Array < any > = [{
			prop: "title",
			label: "优惠券标题",
			width: 100,
		},
		{
			prop: "type_text",
			label: "优惠类型",
			width: 160,
		},
		{
			prop: "term_text",
			label: "有效时间",
			width: 160,
		},
		{
			prop: "grant_text",
			label: "发放数量",
			width: 100,
		},
	];
	const distributionRules: any = {
		user_id: [
			{required: true, message: '请输入用户名称', trigger: 'blur'},
		],
		coupon_id: [
			{required: true, message: '请选择优惠卷', trigger: 'change'},
		],
		
	}
	export default defineComponent({
		name: "VipCard",
		setup() {
			const setTitle: any = inject("setTitle");
			setTitle(["运营管理", '尊享卡管理']);
			let pageSize = ref(10),
				currentPage = ref(1),
				orderStatus = ref(0),
				loading = ref(false),
				total = ref(0),
                roleList = ref({} as any),
				headClass = inject("headClass"),
				project = ref([]),
				Router = useRouter(),
				tableData = ref([] as Array <any> ),
				selectGroup = reactive({
					status: 1,
					date: "",
					search: "",
				}),
				screenParameter: any = {
					page: currentPage.value,
                    pagesize: pageSize.value,
					search: ''
				},
				is_dialog = ref(false),
				distributionForm:any =  ref({
					user_id: '',
					coupon_id: '',
					member: '',
				}),
				distributionFormRef = ref(null),
				distributionForm_isload = ref(false),
				distributionList = ref([] as Array <any> )
			let getTableData = () => {
					loading.value = true;
                    let mydata = {
                        type:1,
                        role_name:'operate_VipCard',
                    };
                    permissionList(mydata).then((res:any)=>{
                        roleList.value = res?.content?.list || 0;
                    });
					Request.axiosInstance({
						url: 'adminapi/VipCard/list',
						data: {...selectGroup,page:currentPage.value,pagesize:pageSize.value}
					}).then((res: any) => {    
						tableData.value = res?.content?.list || [];
						project.value = res?.content?.project || [];
						loading.value = false;
						total.value = res?.content?.total || 0;
					});
				},
				handleSizeChange = (value: number): void => {
					pageSize.value = value;
					getTableData();
				},
				handleCurrentChange = (pageSize: number): void => {
					currentPage.value = pageSize;
					getTableData();
				},
				columnChange = (status: number,id: number) => {
					console.log(id)
					if(id){
						Request.axiosInstance({
						url: 'adminapi/VipCard/upState',
						data: {
							vip_id: id,
							status
						}
					}).then((res: any) => {
						getTableData();
					})
					}
				},
				screenChange = (e: string | Array < any > , key: any): void => {
					// if (!e) {
					// 	delete screenParameter[key];
					// } else {
					// 	if (key == "start_date") {
					// 		let date = [];
					// 		screenParameter["start_date"] = new Date(
					// 			e[0]
					// 		).getTime();
					// 		screenParameter["end_date"] = new Date(e[1]).getTime();
					// 	} else {
					// 		screenParameter["search"] = e as string;
					// 	}
					// }
					getTableData();
				},
				_distribution = () => {
					is_dialog.value = true
					distributionForm_isload.value = true
					getCouponList({status: '1'}).then((res: any) => {
						var list = res?.content?.list || []
						distributionList.value = list
						distributionForm_isload.value = false
					});
					
				},

				//adminapi/VipCard/upState
				_upState = (id: number) => {


					
				},
				_distributionformSubmit = () => {
					
					(distributionFormRef.value as any).validate((valid: boolean) => {
						if(!valid) return
						distributionForm_isload.value = true
						Request.axiosInstance({
							url: "adminapi/Coupon/grant",
							data: distributionForm.value
						}).then((res: any) => {
							distributionForm_isload.value = false
							is_dialog.value = false
						})
						
				
					})
				},
				_option = (url: string , data: any) => {
					Router.push({
						path: url,
						query: data
					})
				
				}

			onMounted(() => {
				getTableData();
			});

			watch(orderStatus, (newValue, oldValue) => {
				//screenParameter.status = orderStatusNav[newValue].id;
				getTableData();
			});

			return {
				selectGroup,
				pageSize,
				currentPage,
				orderStatus,
				columnList,
				loading,
				tableData,
				project,
				handleSizeChange,
				handleCurrentChange,
				total,
				columnChange,
				headClass,
				screenChange,
				is_dialog,
				_distribution,
				_distributionformSubmit,
				distributionForm,
				distributionList,
				distributionForm_isload,
				distributionFormRef,
				distributionRules,
				_option,
                roleList
			};
		},
	});
